/* NYXO — theme.js
   Global chrome: header state, drawers, overlays, qty, wishlist, support search.
   Everything here is progressive enhancement — the theme works without it. */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  var body = document.body;
  var scrim = document.querySelector('[data-scrim]');
  var openState = null; // 'menu' | 'search' | 'cart' | 'filters'
  var lastFocus = null;

  function setScrim(show) {
    if (!scrim) return;
    if (show) {
      scrim.hidden = false;
      requestAnimationFrame(function () { scrim.classList.add('is-visible'); });
    } else {
      scrim.classList.remove('is-visible');
      window.setTimeout(function () { if (!openState) scrim.hidden = true; }, 420);
    }
  }

  function trapFocus(container, e) {
    var focusables = container.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  var panelSelectors = {
    menu: '[data-menu-drawer]',
    search: '[data-search-overlay]',
    cart: '[data-cart-drawer]',
    filters: '[data-filters-panel]'
  };
  function getPanel(name) {
    return name ? document.querySelector(panelSelectors[name]) : null;
  }

  function openPanel(name) {
    closePanel();
    var panel = getPanel(name);
    if (!panel) return;
    lastFocus = document.activeElement;
    openState = name;
    body.classList.add(name + '-open');
    panel.setAttribute('aria-hidden', 'false');
    setScrim(true);
    var focusTarget = panel.querySelector('input:not([type="hidden"]), button, a[href]');
    window.setTimeout(function () { if (focusTarget) focusTarget.focus(); }, 60);
  }

  function closePanel() {
    if (!openState) return;
    var panel = getPanel(openState);
    body.classList.remove(openState + '-open');
    if (panel) panel.setAttribute('aria-hidden', 'true');
    openState = null;
    setScrim(false);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    lastFocus = null;
  }

  window.NYXO = window.NYXO || {};
  window.NYXO.openCart = function () { openPanel('cart'); };
  window.NYXO.closePanels = closePanel;

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) { e.preventDefault(); openPanel('menu'); }
    else if (t.closest('[data-search-open]')) { e.preventDefault(); openPanel('search'); }
    else if (t.closest('[data-cart-open]')) { e.preventDefault(); openPanel('cart'); }
    else if (t.closest('[data-filters-open]')) { e.preventDefault(); openPanel('filters'); }
    else if (t.closest('[data-menu-close], [data-search-close], [data-cart-close], [data-filters-close], [data-scrim]')) {
      e.preventDefault(); closePanel();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closePanel(); }
    if (e.key === 'Tab' && openState) { var p = getPanel(openState); if (p) trapFocus(p, e); }
  });

  /* ---- Header scroll state ---- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var lastY = -1;
    var onScroll = function () {
      var y = window.scrollY;
      if ((y > 12) !== (lastY > 12)) header.classList.toggle('is-scrolled', y > 12);
      lastY = y;
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Quantity steppers (event delegation; works in PDP, drawer, cart page) ---- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('[data-qty]');
    var input = wrap && wrap.querySelector('[data-qty-input]');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var val = parseInt(input.value || '0', 10);
    val = plus ? val + 1 : Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- Wishlist (localStorage, no backend claims) ---- */
  var WISH_KEY = 'nyxo:wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (err) { return []; }
  }
  function paintWishlist() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-handle')) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-handle');
    var list = getWishlist();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (err) { /* private mode */ }
    paintWishlist();
  });
  paintWishlist();
  document.addEventListener('nyxo:cart:rerender', function () {
    paintWishlist();
    if (openState === 'cart') {
      var drawer = getPanel('cart');
      if (drawer) drawer.setAttribute('aria-hidden', 'false');
    }
  });

  /* ---- Support center: client-side topic filter ---- */
  var supportSearch = document.querySelector('[data-support-search]');
  if (supportSearch) {
    supportSearch.addEventListener('input', function () {
      var q = supportSearch.value.trim().toLowerCase();
      document.querySelectorAll('[data-support-topic]').forEach(function (topic) {
        var hit = !q || (topic.getAttribute('data-keywords') || '').toLowerCase().indexOf(q) > -1;
        topic.classList.toggle('is-hidden', !hit);
      });
      document.querySelectorAll('[data-faq-item]').forEach(function (item) {
        var hit = !q || item.textContent.toLowerCase().indexOf(q) > -1;
        item.style.display = hit ? '' : 'none';
      });
    });
  }

  /* ---- Filters: submit builds clean URL (drops empty params) ---- */
  var filtersForm = document.querySelector('[data-filters-form]');
  if (filtersForm) {
    filtersForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var params = new URLSearchParams();
      new FormData(filtersForm).forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
      window.location.href = window.location.pathname + '?' + params.toString();
    });
  }
})();
